module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter01"
    }
  }, [_c('p', {
    staticClass: "ch-title1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('i', [_vm._v("Chapter One")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "ch-title2"
  }, [_c('b', [_vm._v("THE ALLIED TROOPS AND DISPOSITIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The sector into which the five divisions of IX Corps were posted was recognised as being one of the quietest of the whole of the Western Front, and was known to the German forces in the region as "), _c('i', [_vm._v("the sanatorium of the West")]), _vm._v(". Since the French had seized the Chemin des Dames in October 1917, there had been very little activity. The French Sixth Army held a sector some fifty-five miles in length, from Noyon in the west to a point three miles north of Reims in the east. The French General Duchêne’s area of responsibility had almost doubled during March and April 1918, due to the redeployment of troops to the north as a result of the German offensives.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The main topographic feature of the French front was the Chemin des Dames Ridge itself, which runs from the town of Compiègne in the north west to the precipitous buttress of the Californie Plateau above the village of Craonne in the east. The ridge has been compared to the chalky plateau of the Hog’s Back of the North Downs near Guildford. The plateau of the ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Chemin des Dames is a range of heights, roughly 400 feet on average, above the valley of the Aisne. The top of the plateau is gently rolling, particularly in the west between Malmaison and Braye-en-Lannois, and has a breadth of nearly three-quarters of a mile. From Californie Plateau there are commanding views to the south, where the cathedral of Reims can be observed in the distance.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("General Denis Auguste Duchêne, GOC French Sixth Army.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Californie Plateau and the Chemin des Dames, as seen from near Craonnelle.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ridge appears to be a natural fortress, but in many respects this is a mere illusion. Certainly as a defensive bastion it has much to commend itself, a flat topped plateau with some severe slopes to the north and the south. Indeed, Tim Carew in his book "), _c('i', [_vm._v("The Vanished Army")]), _vm._v(" maintains that in September 1914 the German Army, reeling northwards after the First Battle of the Marne, came to the Aisne region and settled on the heights above the river valley and found themselves occupying a defensive position as good as any that could be found between the Urals and the Bay of Biscay. This position offered the German gunners an ideal field of fire, as well as sited battery positions and a number of old stone quarries that could be utilised as storerooms and rest areas. But the heavily wooded slopes and the river valleys of the Aisne (to the south) and the Ailette (to the north) provided cover for attackers, allowing advanced units to creep forward almost totally undetected.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The southern slopes of the Chemin des Dames, occupied by the French Army in 1918, are far from uniform. The countryside consists of gashes of limestone with sides so steep that in places the ascent is a matter of climbing on hands and knees. Although this area had been fought over for a number of months in 1917 as part of the Nivelle Offensive, deciduous woodland still covered substantial acres of the battlefield in 1918. However, the front lines running parallel with the Chemin des Dames had been badly damaged by artillery fire and the white chalk of the underlying rock strata exposed (the Germans called Californie Plateau the ‘Winterberg’). The eastern sector of the French front contrasted markedly with the steep gradients of the area extending along the Chemin des Dames westwards to Soissons: east of Craonne the land drops away abruptly and for twenty miles a low flat plain extends to Reims.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("The Aisne is relatively slow moving, occupying a wide fertile valley, particularly in the west near Soissons. It extends to some 180 feet in width, with many loops and meanders. Little is offered in the way of cover along the riverbank other than high grass during the early summer. Running parallel is the "), _c('i', [_vm._v("Canal Lateral")]), _vm._v(", about sixty feet wide. In some places only a few feet separate the canal and river; in others the gap is up to half a mile. The river and canal are considerable ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("obstacles to north – south movement but there are numerous bridges in the region, with fifty or more in the area from Berry-au-Bac to Soissons alone. The main bulk of the French forces were to be found sandwiched between the high ridge of the Chemin des Dames and the Aisne itself.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The staff of IX Corps reached the French front on 26 April 1918 and decamped at Fère en Tardenois, fifteen miles south east of Soissons. The first formation to arrive was the 50th Division on 27 and 28 April, and gradually over the course of the next two weeks the other divisions of the Corps arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All of these divisions had played an active part in the German offensives of March and April and had suffered heavy losses as a consequence. Time was needed to refit and retrain, and the quiet sector occupied by the Sixth Army seemed to afford them this opportunity. But trained soldiers, NCOs and officers were in short supply by the early summer of 1918. The commander of the 25th Division, Major General Sir Edmund Guy Bainbridge, summed up the situation:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("These reinforcements, largely composed of the nineteen-year-old class, who had been training for the last nine months in England, were most excellent material, but the absence of older men suitable for promotion to NCOs rank was, in some units, a serious disadvantage. A proportion under nineteen years of age were wisely kept back for another two or three months training. It is a thousand pities that they should have been sent from England at all. Owing to age and physique, some of these immature boys were quite incapable of carrying the weight and doing the work required of an infantry soldier in the line: their presence in the ranks rendered them a danger to their units. To use them at the time was only a waste of those who might, later on, with proper training and physical development, have become valuable reinforcements for the Army")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Unit cohesion had all but perished in IX Corps by the time these formations had reached the Chemin des Dames sector. The experience of Second Lieutenant Edwin Joicey was not untypical. In late March 1918, he was notified of his posting to France:")])]), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('i', [_vm._v("Arriving at Dover we saw two or three Staff Officers calling out the names of various Regiments and directing the members of each where they had to go, eventually they found several of us standing as we had not been called. One of the officers asked ‘What Regiment are you?’ we replied ‘Northumberland Fusiliers, sir’ to this the answer was ‘Oh! You bloody Northumberland Fusiliers you are all alike’. We were directed to the boat and on arrival at Boulogne were taken by motor transport and confined to camp. We were there about two days before entraining to join our regiments. I, with one or two others, was instructed to report to the 15th Durham Light Infantry")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Second Lieutenant Edwin Joicey, 15/DLI.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("By May Joicey was in command of his own platoon - he had three weeks to get to know his men before the German attack.")]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Private TH Griffiths. Originally in the West Yorks, he was transferred to the 4/Yorks, KiA aged 18, on 27 May.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1c"
  }, [_c('b', [_vm._v("The Sector held by the British")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The sector that was taken over by IX Corps had been very quiet for a long time; the French and German troops stationed here had practised a live and let live system. Many of the trenches had fallen into disrepair but on paper seemed to offer many positive attributes with regard to defence.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The sector comprised three distinct positions, corresponding to the British system of a Forward Zone, Battle Zone and Rear Zone (Green Line). There were plenty of gun emplacements and many positions afforded good views over the enemy front and rear areas and the Forward Zone had a number of strongpoints all along the front, very well wired and with good deep dugouts. The Battle Zone lay a mile behind the forward positions, consisting of defended localities (often well-fortified hillocks, where battalion and brigade headquarters were stationed) and clear fields of fire for interlocking machine guns. The Rear Zone was located south of the Aisne. The defensive system was very variable here; there were plenty of trenches but no organised system of operation.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The position held by the 50th Division was 8,100 yards wide and No ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Man’s Land in this sector was considerable, up to 2,000 yards or more. The Divisional Headquarters were located in the village of Beaurieux, south of a large wood, the Beaumarais and housed in the local chateau. The area was divided into three sub-sectors, each held by a brigade plus one machine gun company. Each brigade had one battalion in the line, one in support, and one in reserve. Brigadier General Riddell of 149 Brigade provides an excellent account of the dispositions of the 50th Division, as well as the general layout of the defensive arrangements in this sector.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('i', [_vm._v("The sector was a most interesting one, bristling with tactical problems. In the right (149th Bde) and centre (151st Bde) subsectors, the ground formed a very gentle, uniform glacis slope from the Bosch lines down to the river Aisne, with seven steep sided, thickly wooded hillocks, which arose abruptly from the surrounding plain to an average height of sixty feet. A clear view of the right and centre sub-sectors could be obtained, as far as, and including, the Bosch front line and close support trenches; but the remainder of his trench system was lost to view in the woods as it disappeared behind the ridge (parallel to our front line) on which he had his front line system. From this ridge the Bosch could see every movement in our front and support lines, especially in the right sector, where movement along the trenches by day drew the fire of his snipers…The left sub-sector (held by the 150th Bde) had one outstanding feature: the famous Californie Plateau, rising abruptly to a height of 350 feet above the plain, with perhaps, half a dozen bricks to mark the site of the once beautiful village of Craonne. This extraordinary plateau stood out seared and naked, with its almost precipitous slopes disappearing as they fell to the thick woodland which carpeted the plain in every direction except south, east, and again west, where ran the Chemin des Dames")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Brigadier General EPA riddell, GOC 149 Brigade.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The positions held by the 8th Division were different from those of the 50th Division in that the sector formed a right-angled salient, which projected out into the German positions. It was universally a much flatter territory, comprising an Outpost Line some 1,000 to 1,500 yards in depth as well as a Battle Zone 1,500 to 2,000 yards in depth. The front line stretched some 7,500 yards. The right flank rested on the Aisne at the village of Berry-au-Bac. This sub-sector was held by troops of 25 Brigade, with the 2/Rifle Brigade and the 2/Royal Berkshires as well as the 2/East Lancashires in the front line. The regimental history of the East Lancashires provides the following anecdote:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("The line held by the battalion afforded a wide view over the back areas of the enemy’s position; on one occasion a goods train was seen to draw up at a siding where large fatigue parties proceeded in broad daylight to unload it. The artillery was asked to deal with the situation, but declined to do so, pleading that they had been told not to ‘disturb the peace’!")])])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("The Miette stream, roughly twenty feet wide, was located to the north ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("and formed the boundary with 24 Brigade. This brigade occupied the central area and had troops of the 2/Northamptons and the 2/Worcester in line, with the 1/Sherwood Foresters in brigade reserve south of the Aisne. 23 Brigade was positioned on the left flank of the sector, with the 2/Middlesex and the 2/West Yorks in the front line, with the 2/Devons in reserve near the hamlet of La Ville-aux-Bois and the Bois des Buttes. 8/Machine Gun Corps had eight guns in each sub-sector and eight guns in reserve. Another notable feature of this sector was the high wooded area south of the Aisne at Gernicourt. This was a position of some tactical strength, situated as it was on a cliff-like bastion protected by the river. A permanent garrison of 22 Durham Light Infantry (a Pioneer battalion) held the defences in Gernicourt Wood, along with troops from the 11/23rd French Territorial Battalion. Stationed in the vicinity were also French artillery and machine gun companies, all under the command of the 8th Division. Captain Sidney Rogerson, a staff officer of 23 Brigade, vividly portrays the trench system in his part of the line:")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("The ground was everywhere pitted with shell-holes, honeycombed with dug-outs and littered with tangles of barbed wire. Here were concrete ‘pill-boxes’ – super ‘pill-boxes’ – resembling square forts and all bearing the marks of artillery fire; there, in a line, the remains of seven or eight French tanks – a grim memento of the first use of these. But whereas only a year ago it had been an area of death and destruction, in May 1918 Nature had reasserted herself and hidden the grosser evidences of battle under a mantle of green. Only the actual front line trenches, dug in the chalk, seared the landscape with white scars. The woods had been blasted by the shell-fire of the previous year; but now each shattered tree stump had covered its wounds with a wealth of close foliage")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Captain Sidney Rogerson, Headquarters Staff, 23rd Brigade.")])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("The 21st Division held a front line position from near Berry-au-Bac running roughly south easterly for five miles and which ended near the ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("small village of Loivre, which was only three miles from Reims. The forward area of this sector was a chalk plain intersected by the Aisne-Marne canal. The front line ran east of the canal, at one point as much as 1,000 yards beyond it. This forward area lay at the foot of a densely wooded ridge, the Crête St. Auboeuf. The whole area was under view from the enemy heights, Hill 108, Mount Spin and Fort Brimont. To offset this disadvantage, camouflage netting had been set up by the French, which screened all roads and tracks for many miles. The Battle Zone lay to the west of the canal, which consisted of a chain of redoubts, which ran in front of the Laon-Reims "), _c('i', [_vm._v("route national")]), _vm._v(". This area was considered to be the main line of resistance.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("The Chemin des Dames and the Winterberg.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("The trenches in this sector were very similar to those in other areas of the IX Corps front. There was too many of them. It was a complex system that resembled a rabbit warren, especially the communication trenches. The second and third lines were very badly sited and with no field of fire. These trenches were positioned on the top of ridges instead of being positioned further down the slopes (on 27 May the Germans did not bother about the ridges but went around them in every case by the valleys). The main weakness on 21st Division’s front was the Forward Zone across the canal. This had been sited at the limit of the French advance in 1917. The area was very low lying, and Lieutenant Colonel Harold Franklyn (GSO I 21st Division) commented, ‘I don’t ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("think ‘canal’ gives the right impression. Actually it was a swamp about 100 yards or more broad crossed by duck-boards tracks.’")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "h1c"
  }, [_c('b', [_vm._v("Anglo French Co-operation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("One of the most significant factors that contributed to the disaster on 27 May was the difference of opinion that existed between the British and the French as to the best defensive strategy to adopt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Commander-in-Chief of the French Armies, General Pétain, had laid down new principles for defensive arrangements at the end of 1917. Having observed the innovative "), _c('i', [_vm._v("Stosstruppen")]), _vm._v(" tactics in operation on the Chemin des Dames in July 1917; and having also taken note of German instructional pamphlets with regard to the construction of defensive positions, Pétain realised the shortcomings of the allied defence. There had to be a greater degree of flexibility; it was no longer safe to pack the Forward Zone with troops. Front line positions should be held lightly, with only enough soldiers stationed there to slow down the assaulting waves of the enemy. The main line of resistance was to be the Second Position (the British termed this the Battle Zone). This was to be the killing ground and was designed to ensure that it could not be reached by attacking troops until they had already been delayed and to be so far back as to deny them artillery support. However, support for this new ‘elastic defence’ was far from unanimous. General Laure, a member of the Operations Bureau of General Pétain’s General Staff, pointed out what he saw as folly:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("At the front, as in the bosom of the Government, there was stupefaction. Here was a General-in-Chief who deliberately contemplated the eventual abandonment of the famous Buttes in Champagne, conquered in 1915 at the cost of so much blood; of the advanced lines of Verdun, like Hill 304, of the heights of the Talon and the Poivre, on which were inscribed the victories of 1916; of the Chemin des Dames and the knolls of Morainvillers, the capture of which had been the only positive results of the attacks of 16th April 1917")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Another detractor was the commander of the Sixth Army, General Denis Duchêne. He clung to the view that the defensive battle must be fought on the Forward Zone, without yielding ground. Reluctantly, Pétain gave way and approved the retention of the Chemin des Dames as a position of resistance, with the proviso, ‘None of the divisions of the 6th Army placed in reserve were to be brought north of the Aisne.’")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Duchêne’s motives for holding on to the Chemin des Dames were purely emotional; he argued that no ground in the sector, which covered Paris, should be voluntarily given up. To do so would fly in the face of public opinion; giving up the Chemin des Dames, which had been so bitterly contested and won from the Germans the previous year, would almost have been tantamount to surrendering Fortress Verdun. A further concern may have been that the French were also reluctant to be compared to the faltering BEF (British Expeditionary Force) in the recent battles on the Somme and Lys:")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("The country would not have understood that from the experience gathered from the British front alone, a position so rich in French blood and thought to be impregnable had been given up. A certain presumption, this writer thinks, may have asserted itself in French minds: ‘The English had fallen away before the enemy’s great assault, but the French would stand!’")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The great weaknesses of the Chemin des Dames defence were that it lacked depth and that the Aisne, standing five miles to the rear, was a considerable obstacle. The British commander, Lieutenant General Hamilton-Gordon, and his subordinates, free from the symbolic necessity of having to hold on to the ridge, were quick to point out the shortcomings of the defensive arrangements in this area. Using the Aisne as the main line of defence, the ridge would become merely a line of outposts. In other words, this area would have been almost ideal for deploying a defence in depth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Duchêne seems to have been loathed by most of his contemporaries although, if not admired by the troops under his command, he was respected and was given the nickname "), _c('i', [_vm._v("Tigre Militare")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("The word was that the General was foul tempered, perpetually angry and foulmouthed for no reason. Approaching him became a form of torture for his officers, which they dared do only at the last resort. His Chief of Staff, obliged to submit to his outbreaks of anger, sulked for several days when the General went too far")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("He was not a man who would listen to advice from subordinate commanders. By contrast, Hamilton-Gordon comes across as being weak and indecisive. His dour disposition does not seem to have helped his cause, leading to him being ironically referred to as ‘Sunny Jim’ and ‘Merry and Bright’.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The differences of opinion between the British and the French with regard to defence came to a head at a conference on 15 May at IX Corps Headquarters. All his divisional commanders, in respect of the ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("front line dispositions of the British troops, made protests to Hamilton-Gordon. As Major General Heneker (Commander of the 8th Division) pointed out:")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("This was contrary to what all the British Divisional Commanders had learnt ‘up north’ during the battles we had been in, viz to evacuate the forward zone out of trench mortar range")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("These protests were relayed to the French Commander, who replied, ‘You English have learnt up north how to retreat, I will teach you to stand.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This sorry situation placed Hamilton-Gordon in an awkward position. In charge of a relatively small force under a French commander of higher rank on French soil, he could do little but register his protests to GHQ. It was too little and, in the event, too late for those troops enjoying much needed respite from action until the last week in May in what was a tranquil and placid sector.")]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Major General Sir WG Henneker, GOC 8th Division.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Royal Engineers from the 50th Division newly arrived on the Aisne, May 1918 (Helen Charlesworth).")])])]), _c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "map_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_20.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("German Offensives May-June 1918 (from German Official History).")])])]), _c('p', {
    staticClass: "h1c"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('b', [_vm._v("The German Plan and Preparations")])])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For more than a month Ludendorff had been planning an attack across the Chemin des Dames. Operation Blücher, named after the famous Prussian Marshal from the Napoleonic era, was only to be a diversionary attack. After the German army had surmounted the steep ridge above the Aisne, they would press on to the Marne. Ludendorff anticipated that the French would panic and transfer all reserve forces from the Flanders region to cover what they believed would be a direct assault against the French capital. Having in effect divided the Allied armies, the main blow of the attack would be launched against Haig’s forces in the north. Preparations would demand almost total secrecy to achieve the operational surprise that was required for success. The attack was to take place on 27 May 1918.")]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Gebhard Leberecht von Blücher in Laon, 1815.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("A thirty-five mile front between Soissons and just to the north of Reims was selected as the prime focus of the offensive. Two Armies were to be responsible for delivering this attack. The German Seventh Army, under the command of Generaloberst Max von Boehn, was tasked with the main assault, with subsidiary support on the easterly flank from the First Army under General der Infanterie Fritz von Below. The Seventh Army consisted of six corps, two of these, under the command of General Richard von Conta (IV Reserve Corps), and ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("General Graf von Schmettow (LXV Corps), faced the British contingent. Some forty-one German infantry divisions were massed along the front. The Allies in comparison had nine weak divisions from the French Sixth Army as well as three from the depleted British IX Corps.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Preparation for the offensive was meticulous. All movement was confined to the dark of night. Nature helped to contribute to the concealment. The area between Laon and the front line was in places heavily forested, it was spring and the trees were in full leaf. This region proved ideal in providing storage depots for the vast amounts of ammunition and other supplies that were required for the operation. The mating sounds of thousands of frogs in the Ailette valley also helped to mask the sounds of troops, supplies and ammunition being ushered forward. The wheels of all vehicles on the move were well-greased and even fitted with leather coverings, iron-rimmed wheels were padded with tyres of wool-wood or rags, and every artillery piece with loose metal was wrapped in straw. Even horses’ hooves were padded with cloth. Additionally, no vehicle on road or rail displayed a label or any other distinguishing feature.")]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("General Max von Boehn, commanding the German Seventh Army.")])])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Artillery was to play the decisive role. Much depended on the fire plan of Oberst Georg Bruchmüller, the master gunner technician of the earlier German offensives of March and April. Some 5,263 guns were to be used against the Allies’ 1,422 – the greatest superiority ratio achieved by the Germans in any of their battles during the course of the Great War. Ludendorff had total faith in his artillery commander and as a mark of respect he made Bruchmüller artillery chief of Crown Prince Wilhelm’s Army Group shortly before the battle commenced. One of the innovations for this battle was that guns and trench mortars were to use only gas shells for the first ten minutes. This was designed to create panic and to demoralise right from the start. The next phase of the barrage consisted of a bombardment of mixed gas and high ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("explosive targeted at French and British artillery positions, as well as mortar shelling of front line defences. In total the artillery preparation lasted two hours and forty-five minutes, the shortest but the most concentrated of any of the German attacks of 1918.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Oberst Georg Bruchmüller, commanding German Seventh Army Artillery.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("German railway gun used in the attack on 27 May.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the days running up to the battle confidence on the German side remained high. Major General AD von Unruh, Chief of Staff of von Conta’s IV Reserve Corps, had carried out a detailed reconnaissance of the sector occupied by British troops and helped plan the German assault on Californie Plateau. He was summoned before Ludendorff and asked what he expected would be the extent of the German advance on the first day. He had no doubts. He predicted that German troops would reach the Vesle River, some twelve miles to the south. This would mean that the Chemin des Dames and the Aisne would be in German hands by the afternoon of 27 May: ‘Our preparations were so thorough that, if the information of their weakness in numbers was correct, we should overrun the English.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Corporal Adolf Hitler, of the 16th Bavarian Reserve Infantry List Regiment, later recalled his experiences on the eve of the battle:")]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("We set off for the second offensive in 1918 on the night of the 25th. On the 26th we spent the night in a forest, and on the morning of the 27th we prepared for duty. At 5 o’clock in the morning we departed. The day before, during the afternoon, we received reinforcements for the big offensive at the Chemin des Dames")]), _vm._v(".")])])]), _c('p', {
    staticClass: "fig-img",
    attrs: {
      "id": "map_5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_25.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("The 50 Division on the eve of battle.")])])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f129f65e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter01.vue
// module id = 84
// module chunks = 0